import React from 'react';
import { Helmet } from 'react-helmet';
import { useAppSelector } from 'hooks/useStore';
import EssaysSection from './EssaysSection';

// Standalone /fillapp/essays page. The essays grid + create modal live in the
// shared EssaysSection (also embedded on the College Apps dashboard).
function Essays() {
    const { organization } = useAppSelector(state => state.organization);
    return (
        <>
            <Helmet><title>Essay Review - {organization.name}</title></Helmet>
            <EssaysSection variant='page' />
        </>
    );
}

export default Essays;
